import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import Measure from 'react-measure';
import { DEFAULT_BANNER } from '../../../constants/userNotificationBannerComponentTypes';
import DefaultBanner from './DefaultBanner';
import { getUserNotificationBanner } from '../../UserNotifications/ducks/selectors';
import { userNotificationOperations } from '../../UserNotifications/ducks';
import { BannerWrapper } from './UserNotificationBanner.styles';

const bannerComponentTypeMapping = {
  [DEFAULT_BANNER]: DefaultBanner
};

class UserNotificationBanner extends React.Component {
  state = {
    isBannerDismissed: false,
    bannerDimensions: { height: 0 }
  };

  dismissBanner = () => {
    const { userNotificationBanner, dismissUserNotification } = this.props;
    this.setState({ isBannerDismissed: true });
    return dismissUserNotification(userNotificationBanner.notificationId);
  };

  render() {
    const { userNotificationBanner } = this.props;
    const { isBannerDismissed } = this.state;
    const { componentType } = userNotificationBanner;
    const Banner = bannerComponentTypeMapping[componentType];
    const className = classnames({
      'is-dismissed': isBannerDismissed
    });

    if (!Banner) return null;

    return (
      <Measure bounds onResize={contentRect => this.setState({ ...this.state, bannerDimensions: contentRect.bounds })}>
        {({ measureRef }) => {
          return (
            <BannerWrapper height={this.state.bannerDimensions.height} className={className}>
              <div ref={measureRef}>
                <Banner userNotification={userNotificationBanner} dismissUserNotification={this.dismissBanner} />
              </div>
            </BannerWrapper>
          );
        }}
      </Measure>
    );
  }
}

UserNotificationBanner.propTypes = {
  dismissUserNotification: PropTypes.func.isRequired,
  userNotificationBanner: PropTypes.shape({})
};

UserNotificationBanner.defaultProps = {
  userNotificationBanner: null
};

const mapStateToProps = state => {
  return {
    userNotificationBanner: getUserNotificationBanner(state)
  };
};

const mapDispatchToProps = {
  dismissUserNotification: userNotificationOperations.dismissUserNotification
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserNotificationBanner);
